export default __webpack_public_path__ + "static/char-v-21-e18f6a957e0eb92d6aac19a254fffce4.webp";